import { WaveformIcon as PhosphorWaveformIcon } from "@phosphor-icons/react/dist/ssr/Waveform";

import { createAppIcon } from "@/components/createAppIcon";

export const WaveformIcon = /* @__PURE__ */ createAppIcon(PhosphorWaveformIcon);
